<template>
  <div id="update-data-page">
    <h2 class="intro-y text-lg font-medium mt-10">
      更改預約
    </h2>

    <resource-booking-form v-if="checkPermission(permissions, ['site.resource-booking.edit']) || (profile !== null && data !== null && profile.user_id === data.user_id)" :data="data" :site="currentSite"></resource-booking-form>
  </div>
</template>

<script>
export default {
  props: ['auth', 'currentSite', 'permissions', 'profile'],
  data() {
    return {
      mounted: false,
      data: null
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    currentSite() {
      this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.currentSite) {
        await this.loadData()

        this.mounted = true
      }
    },
    async loadData() {
      this.data = await this.getSiteResourceBooking(this.currentSite.site_id, this.$route.params.bookingId)
    }
  }
}
</script>

<style lang="scss" scoped></style>
